import styled from "styled-components";
import * as Type from "../../../../../../../common-deprecated/styles/v2/toyota/globals/Type";
import * as CashPrice from "../../../../../../../common-deprecated/styles/v2/toyota/custom/price/CashPrice";
import * as MonthlyPrice from "../../../../../../../common-deprecated/styles/v2/toyota/custom/price/MonthlyPrice";
import * as Button from "../../../../../../../common-deprecated/styles/v2/toyota/components/Button";
import * as Tag from "../../../../../../../common-deprecated/styles/toyota/Tag";
import { IconWrapper } from "../../../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import { theme } from "../../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";
import { getBreakpoint } from "../../../../../../../common-deprecated/themes/common";

export const Wrapper = styled.article<{ selected?: boolean }>`
    display: flex;
    position: relative;
    flex-wrap: wrap;
    width: 100%;
    padding: ${theme.space[4]}px ${theme.space[4]}px 0;
    background: ${theme.colors.primaryWhite};
    box-shadow: ${({ selected }) =>
        selected ? `0 0 0 2px ${theme.colors.primaryBlack}` : "0 2px 12px rgba(0, 0, 0, 0.16)"};
    transition: all 0.55s ease-out;
    overflow: hidden;

    @media ${getBreakpoint("up", "xl")} {
        padding: ${theme.space[4]}px;
    }
`;

export const Header = styled.header`
    order: 2;
    @media ${getBreakpoint("up", "md")} {
        order: 1;
        width: 50%;
    }
    @media ${getBreakpoint("up", "xl")} {
        width: calc(100% / 3);
    }

    /* Style eco label in header */
    ${Tag.Eco} {
        flex-direction: row;
        align-items: center;
        gap: ${theme.space[1]}px;
        width: 100%;
        height: auto;
    }
    ${Tag.Motorisation} {
        margin-top: 0;
    }
`;

export const Content = styled.div`
    order: 3;
    width: 100%;
    margin: ${theme.space[2]}px 0 ${theme.space[3]}px;
    padding-top: ${theme.space[2]}px;
    border-top: 1px solid ${theme.colors.grey2};

    @media ${getBreakpoint("up", "md")} {
        order: 2;
        width: 50%;
        margin: 0;
        padding-top: 0;
        border-top: 0;
    }
    @media ${getBreakpoint("up", "xl")} {
        width: calc(100% / 3);
    }
`;

export const ImageWrapper = styled.div<{ isRTL: boolean }>`
    position: relative;
    order: 1;
    text-align: center;

    ${Button.ButtonTertiary} {
        display: none;
    }

    img {
        transform: ${({ isRTL }) => (isRTL ? "scaleX(-1)" : "scaleX(1)")};
    }

    @media ${getBreakpoint("up", "md")} {
        order: 3;
        width: 50%;
        padding-bottom: ${theme.space[5]}px;
    }
    @media ${getBreakpoint("up", "xl")} {
        width: calc(100% / 3);

        ${Button.ButtonTertiary} {
            display: inline-block;
        }

        img {
            margin-bottom: ${theme.space[2]}px;
        }
    }
`;

export const GradeName = styled.h2`
    ${Type.h4Style};
    margin-bottom: ${theme.space[1]}px;
    text-transform: none;
    color: ${theme.colors.primaryBlack};
`;

export const BodyTypeName = styled.h3<{ isSmall?: boolean }>`
    ${Type.bodyStyle};
    margin-bottom: 0;
    color: ${theme.colors.grey4};
`;

export const PriceWrapper = styled.div.attrs(() => ({
    className: "t-base-headline",
}))`
    margin-bottom: ${theme.space[2]}px;
    text-align: start;

    /* Styles prices */
    ${CashPrice.Text},
    ${MonthlyPrice.Text} {
        ${Type.bodyStyle};
        color: ${theme.colors.primaryBlack};
    }

    ${MonthlyPrice.PricesWrapper} + ${CashPrice.PricesWrapper} {
        ${CashPrice.Text} {
            color: ${theme.colors.primaryBlack} !important;
        }
    }

    /* Style disclaimer button */
    ${Button.Link} {
        color: ${theme.colors.grey4};
        ${IconWrapper} {
            order: 2;
        }
        ${Type.SmallText} {
            color: ${theme.colors.grey4};
        }
    }
`;

export const GRLogo = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    width: 50px;
    z-index: 1;
`;
